/*
 *  Main Header
 *
 *  Version:
 *    1.0.0 - 2019/11/10
 */

import * as ResponsiveSizes from './../../settings/Responsive';
import { register, ShopifySection } from './../../sections/ShopifySection';
import { getCurrentCart, ON_CART_FINISHED } from './../../process/pc-slate-tools';

export const SELECTOR_CONTAINER = '[data-main-header]';
export const DESKTOP_NAV_INNER = '[data-main-header-inner]';
export const HAMBURGER_BUTTON = '[data-hamburger-menu-toggle]';
export const SELECTOR_MAIN_WRAPPER  = '[data-main-wrapper]';
export const MOBILE_DRAWER = '[data-data-mobile-drawer]';
export const MOBILE_MENU_LINK = '[data-menu-link]';
export const MOBILE_MENU_LINK_2 = '[data-menu-link-lv-2]';
export const MOBILE_NAV_CONTAINER = '[data-data-mobile-drawer]';
export const MOBILE_NAV_MAIN = '[data-mobile-nav-main]';
export const MOBILE_NAV_MENU = '[data-nav-menu]';
export const MOBILE_BACK_MENU = '[data-back-menu]';
export const MOBILE_SUB = '[data-submenu]';
export const CART_COUNTER = '[data-cart-counter]';


export const SELECTOR_HEADER_WRAPPER = '[data-header-wrapper]';
export const SELECTOR_TOPBAR = '[data-topbar]';

export const SELECTOR_MEGA_BUTTON  = '[data-mega-menu]';
export const SELECTOR_MEGA_WRAPPER  = '[data-mega-menu-wrapper]';
export const SELECTOR_MEGA_HEIGHT  = '[data-mega-menu-height]';
export const SELECTOR_MEGA_NAV  = '[data-mega-col]';
export const SELECTOR_MEGA_NAV_SUPCOL  = '[data-mega-subcol]';

export const DATA_MENU = 'data-menu';
export const DATA_MEGA_NAV = 'data-mega-col';
export const DATA_MEGA_NAV_SUBCOL = 'data-mega-subcol';

export const SELECTOR_SEARCH_BUTTON  = '[data-header-search-button]';
export const SELECTOR_SEARCH_BUTTON_CLOSE  = '[data-header-search-close-button]';
export const SELECTOR_SEARCH_BOX  = '[data-header-search]';
export const SELECTOR_SEARCH_INPUT  = '[data-header-search-input]';

// class
export const CLASS_ACTIVE = 'is-active';
export const CLASS_MENU_OPEN = 'is-menu-open';
export const CLASS_FIXED_SCROLL = 'is-fixed-scroll';
export const CLASS_SUBMENU_OPEN = 'is-submenu-open';
export const CLASS_SUBMENU_2_OPEN = 'is-submenu-2-open';
export const CLASS_MOVE_LEFT = 'is-move-left';
export const CLASS_SHOW_LV2 = 'is-show-lv2';
export const CLASS_HAS_SUBCOL = 'has-subcol';
export const CLASS_SUBMENU_ACTIVE = 'is-active-submenu';

export const CLASS_HOVER = 'on-hover';

export class MainHeader extends ShopifySection {
  constructor(container) {
    super(container);

    this.container = container;
    this.headerWrapper = container.closest(SELECTOR_HEADER_WRAPPER);
    this.topbar = this.headerWrapper.find(SELECTOR_TOPBAR);
    this.hamburgerButton = container.find(HAMBURGER_BUTTON);
    this.mobilemain = container.find(MOBILE_NAV_MAIN);
    this.mobileDrawer = container.find(MOBILE_DRAWER);
    this.mainWrapper = container.closest(SELECTOR_MAIN_WRAPPER);
    this.submenus = container.find(MOBILE_SUB);
    this.meganavButton = container.find(SELECTOR_MEGA_BUTTON);
    this.meganav = container.find(SELECTOR_MEGA_WRAPPER);
    this.meganavItems = container.find(SELECTOR_MEGA_NAV);
    this.meganavSubcol = container.find(SELECTOR_MEGA_NAV_SUPCOL);
    this.searchBox = container.find(SELECTOR_SEARCH_BOX);
    this.cartCounter = container.find(CART_COUNTER);

    this.container.on('click touchend', HAMBURGER_BUTTON, e => this.openMobileMenu(e));
    this.container.on('click touchend', MOBILE_MENU_LINK, e => this.openMobileSubMenu(e));
    this.container.on('click touchend', MOBILE_MENU_LINK_2, e => this.openMobileSubMenu2(e));
    this.container.on('click touchend', MOBILE_BACK_MENU, e => this.openMobileBackMenu(e));
    this.container.on('click touchend', SELECTOR_SEARCH_BUTTON, e => this.openSearchForm(e));
    this.container.on('click touchend', SELECTOR_SEARCH_BUTTON_CLOSE, e => this.closeSearchForm(e));

    $(window).on('resize orientationchange', () => this.onResize());
    $(document).on(ON_CART_FINISHED, () => this.updateCartCount());
    this.onHoverNav();

    // Check a newsletter form submission has been completed, then scroll to newsletter
    this.checkNewsletterSubmission();
  }

  openMobileMenu(e){
    e.stopPropagation();
    e.preventDefault();

    this.hamburgerButton.toggleClass(CLASS_ACTIVE);
    this.mobileDrawer.toggleClass(CLASS_MENU_OPEN);
    this.container.toggleClass(CLASS_MENU_OPEN);

    // diable page scrolling
    if (this.mobileDrawer.hasClass(CLASS_MENU_OPEN)) {
      $('html,body').addClass(CLASS_FIXED_SCROLL);
      this.mainWrapper.addClass(CLASS_MENU_OPEN);
    } else {
      $('html,body').removeClass(CLASS_FIXED_SCROLL);
      this.mainWrapper.removeClass(CLASS_MENU_OPEN);
    }
  }

  openMobileSubMenu(e){
    e.stopPropagation();
    e.preventDefault();

    let menuitem = $(e.currentTarget);
    let target = menuitem.attr(DATA_MENU);
    let submenu = menuitem.siblings('['+DATA_MENU+'='+target+']');
    let navContainer = menuitem.closest(MOBILE_NAV_CONTAINER);
    let mobilenavMain = menuitem.closest(MOBILE_NAV_MAIN);

    submenu.addClass(CLASS_SUBMENU_OPEN);
    navContainer.addClass(CLASS_SUBMENU_OPEN);
    mobilenavMain.addClass(CLASS_MOVE_LEFT);

    let oldElems = document.getElementsByClassName(CLASS_SUBMENU_ACTIVE);
    $(oldElems).removeClass(CLASS_SUBMENU_ACTIVE);

    submenu.addClass(CLASS_SUBMENU_ACTIVE);
  }

  openMobileSubMenu2(e){
    e.stopPropagation();
    e.preventDefault();

    let menuitem = $(e.currentTarget);
    let target = menuitem.attr(DATA_MENU);
    let submenu = menuitem.siblings('['+DATA_MENU+'='+target+']');
    // let navContainer = menuitem.closest(MOBILE_NAV_CONTAINER);
    let mobilenavMain = menuitem.closest(MOBILE_NAV_MAIN);

    submenu.addClass(CLASS_SUBMENU_2_OPEN);
    mobilenavMain.addClass(CLASS_SHOW_LV2);

    let oldElems = document.getElementsByClassName(CLASS_SUBMENU_ACTIVE);
    $(oldElems).removeClass(CLASS_SUBMENU_ACTIVE);

    submenu.addClass(CLASS_SUBMENU_ACTIVE);
  }

  openMobileBackMenu(e){
    e.stopPropagation();
    e.preventDefault();

    let backButton = $(e.currentTarget);
    let submenu = backButton.closest(MOBILE_NAV_CONTAINER);
    let submenuContainer = backButton.closest(MOBILE_SUB);

    let mobilenavMain = backButton.closest(MOBILE_NAV_MAIN);

    submenu.removeClass(CLASS_SUBMENU_OPEN);
    submenuContainer.removeClass(CLASS_SUBMENU_OPEN);
    if (submenuContainer.hasClass("is-lv-2")) {
      submenu.removeClass(CLASS_SUBMENU_2_OPEN);
      submenuContainer.removeClass(CLASS_SUBMENU_2_OPEN);
    }
    if (mobilenavMain.hasClass(CLASS_SHOW_LV2)) {
      mobilenavMain.removeClass(CLASS_SHOW_LV2);
    } else{
      mobilenavMain.removeClass(CLASS_MOVE_LEFT);
    }
  }

  onMouseOverNav(e) {
    e.stopPropagation();
    e.preventDefault();

    let self = $(e.currentTarget);

    this.meganavButton.removeClass(CLASS_MENU_OPEN);
    this.topbar.removeClass(CLASS_MENU_OPEN);

    self.addClass(CLASS_MENU_OPEN);

    if (self.hasClass('has-submenu')) {
      this.container.addClass(CLASS_HOVER);
      this.topbar.addClass(CLASS_HOVER);
    }
  }

  onMouseLeaveNav() {
    this.container.removeClass(CLASS_HOVER);
    this.meganavButton.removeClass(CLASS_MENU_OPEN)
    this.topbar.removeClass(CLASS_HOVER);
  }

  onMouseOverNavItem(e){
    e.stopPropagation();
    e.preventDefault();

    let self = $(e.currentTarget);
    let id = self.attr(DATA_MEGA_NAV);
    let target = this.meganav.find("["+DATA_MEGA_NAV_SUBCOL+"="+id+"]");

    this.meganavItems.removeClass(CLASS_ACTIVE);
    self.addClass(CLASS_ACTIVE);
    if (target.length == 0) return;
    this.meganavItems.removeClass(CLASS_HAS_SUBCOL);
    this.meganavSubcol.removeClass(CLASS_ACTIVE)
    self.addClass(CLASS_HAS_SUBCOL);
    target.addClass(CLASS_ACTIVE);

    // Adjust height for the meganav
    let wrapperH = this.container.find(SELECTOR_MEGA_HEIGHT);
    let wrapperHeight = wrapperH.height();

    // if(this.meganavHeight) clearTimeout(this.meganavHeight);
    // this.meganavHeight = setTimeout(() => {
    //   this.meganav.css('height',wrapperHeight);
    // }, 100);
  }

  onHoverNav(){
    if($(window).width() < ResponsiveSizes.medium) return;

    // change header bg color when meganav open;
    if(this.headerResize) clearTimeout(this.headerResize);
    this.headerResize = setTimeout(() => {
      $(document).on('mouseenter', SELECTOR_MEGA_BUTTON, e => this.onMouseOverNav(e));
      $(document).on('mouseleave', (DESKTOP_NAV_INNER), e => this.onMouseLeaveNav(e));
      $(document).on('mouseenter', (MOBILE_NAV_MENU), e => this.onMouseLeaveNav(e));
      $(document).on('mouseleave', (SELECTOR_MEGA_WRAPPER), e => this.onMouseLeaveNav(e));

      // Nav items
      $(document).on('click touchend', SELECTOR_MEGA_NAV, e => this.onMouseOverNavItem(e));
    }, 100);
  }


  onMobile(){
    // console.log("this is mobile")
  }

  onDesktop(){
    // disable mobile hanburger
    this.hamburgerButton.removeClass(CLASS_ACTIVE);
    this.mobileDrawer.removeClass(CLASS_MENU_OPEN);
    this.container.removeClass(CLASS_MENU_OPEN);

    // diable page scrolling
    $('html,body').removeClass(CLASS_FIXED_SCROLL);
    this.mainWrapper.removeClass(CLASS_MENU_OPEN);

    // close submenu
    this.submenus.removeClass(CLASS_SUBMENU_OPEN);
    this.mobilemain.removeClass(CLASS_MOVE_LEFT);
    this.mobilemain.removeClass(CLASS_SHOW_LV2);
  }

  onResize(){
    if(this.ResizeTimer) clearTimeout(this.ResizeTimer);
    this.ResizeTimer = setTimeout(() => {

      // on mobile
      if($(window).width() < ResponsiveSizes.medium-1){
        this.onMobile();
      } else {
        this.onDesktop();
      }

      this.ResizeTimer = null;
    }, 100);
  }

  openSearchForm(e){
    e.stopPropagation();
    e.preventDefault();
    $(SELECTOR_SEARCH_INPUT).focus();
    this.searchBox.toggleClass('is-opened');
  }

  closeSearchForm(e){
    e.stopPropagation();
    e.preventDefault();

    this.searchBox.toggleClass('is-opened');
  }

  updateCartCount() {
    let cart = getCurrentCart();
    if(cart.item_count > 0){
      this.cartCounter.text(cart.item_count)
      this.cartCounter.addClass('has-item')
    }
  }

  getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
  }

  checkNewsletterSubmission() {
    const QUERY_NEWSLETTER_PARAM = 'contact%5Btags%5D';
    let params = this.getUrlVars();
    let queryNewsletterParam = params[QUERY_NEWSLETTER_PARAM];
    if(queryNewsletterParam == 'newsletter') {
      this.scrollToNewsletter();
    }
  }

  scrollToNewsletter() {
    const NEWSLETTER_SIGNUP_ELEMENT = '.o-newsletter-signup-form__container';
    const SCROLL_SPEED = 2000;

    $(document).ready(function(){
      let newsletterSignUpForm = $(NEWSLETTER_SIGNUP_ELEMENT)
      if(newsletterSignUpForm){
        $('html, body').animate({
          scrollTop: newsletterSignUpForm.offset().top
        }, SCROLL_SPEED);
      }
    });
  }
}

register(SELECTOR_CONTAINER, MainHeader);